export default {
  "首页": "Inicio",
  "订单": "Pedidos",
  "新闻": "Noticias",
  "个人中心": "Perfil",
  "模拟账户": "Cuenta Demo",
  "可用资产": "Activos Disponibles",
  "入金": "Depósito",
  "出金": "Retiro",
  "账单详情": "Detalles de Factura",
  "重置模拟账户": "Restablecer Cuenta Demo",
  "钱包": "Cartera",
  "实名认证": "Verificación de Identidad",
  "邀请好友": "Invitar Amigos",
  "修改密码": "Cambiar Contraseña",
  "投诉邮箱": "Correo de Quejas",
  "其它": "Otros",
  "公告": "Anuncios",
  "语言": "Idioma",
  "是否退出登录": "¿Cerrar sesión?",
  "复制": "Copiar",
  "复制成功": "Copiado con Éxito",
  "发送验证码成功": "Código de Verificación Enviado con Éxito",
  "请输入密码": "Por Favor, Introduzca la Contraseña",
  "请再次输入密码": "Por Favor, Introduzca la Contraseña de Nuevo",
  "复制邀请链接": "Copiar Enlace de Invitación",
  "上传身份": "Por Favor, Suba el Anverso y Reverso de su ID/Pasaporte",
  "正面": "Anverso",
  "上传正面": "Subir Anverso del ID/Pasaporte",
  "反面": "Reverso",
  "上传反面": "Subir Reverso del ID/Pasaporte",
  "完善信息": "Por Favor, Complete su Información Personal",
  "输入姓名": "Por Favor, Introduzca su Nombre",
  "身份证号": "Número de ID/Pasaporte",
  "输入身份证号": "Por Favor, Introduzca su Número de ID/Pasaporte",
  "收款货币": "Moneda de Cobro",
  "银行名称": "Nombre del Banco",
  "收款人账户": "Cuenta del Beneficiario",
  "货币": "Moneda",
  "分店名称": "Nombre de la Sucursal",
  "绑定银行卡": "Vincular Tarjeta Bancaria",
  "银行地址": "Dirección del Banco",
  "账号名称（假名）": "Nombre de la Cuenta (Alias)",
  "绑定数字货币地址": "Vincular Dirección de Criptomoneda",
  "余额": "Saldo",
  "联系客服": "Contactar Soporte",
  "行情": "Mercado",
  "其他": "Otros",
  "设置": "Configuración",
  "收款人": "Beneficiario",
  "添加": "Añadir",
  "确认": "Confirmar",
  "取消": "Cancelar",
  "钱包地址": "Dirección de la Cartera",
  "请输入": "Por Favor, Introduzca",
  "退出登录": "Cerrar Sesión",
  "充值数量": "Cantidad a Recargar",
  "提交": "Enviar",
  "银行卡": "Tarjeta Bancaria",
  "选择网络": "Seleccionar Red",
  "数字货币": "Criptomoneda",
  "上传验证": "Subir Verificación",
  "提币地址": "Dirección de Retiro",
  "数量(USD)": "Cantidad (USD)",
  "备注": "Notas",
  "手续费": "Comisión",
  "预计到账数量": "Cantidad Estimada a Recibir",
  "暂无数据": "Sin Datos Disponibles",
  "入金记录": "Historial de Depósitos",
  "提币记录": "Historial de Retiros",
  "验证码": "Código de Verificación",
  "邀请码": "Código de Invitación",
  "提示": "Aviso",
  "请输入验证码": "Por Favor, Introduzca el Código de Verificación",
  "姓名": "Nombre",
  "邮箱登录": "Iniciar Sesión con Email",
  "邮箱": "Email",
  "密码": "Contraseña",
  "新用户": "Nuevo Usuario",
  "立即加入": "Únete Ahora",
  "忘记密码": "Olvidé mi Contraseña",
  "登录": "Iniciar Sesión",
  "无需开户,立即创建模拟账号进行交易!": "¡Sin Necesidad de Crear una Cuenta, Comienza a Operar con una Cuenta Demo Ahora!",
  "电话": "Teléfono",
  "再次输入密码": "Introduzca la Contraseña Nuevamente",
  "职业": "Ocupación",
  "年收入": "Ingresos Anuales",
  "注册": "Registrarse",
  "邮箱注册": "Registro por Email",
  "发送": "Enviar",
  "重置密码": "Restablecer Contraseña",
  "是否重置": "¿Restablecer?",
  "已重置": "Restablecido",
  "名称": "Nombre",
  "注册成功": "Registro Exitoso",
  "加载中": "Cargando",
  "您还未登录，请先登录": "Aún no ha iniciado sesión, por favor inicie sesión primero",
  "退出成功": "Cierre de Sesión Exitoso",
  "市价": "Precio de Mercado",
  "挂单": "Orden Pendiente",
  "倍数": "Multiplicador",
  "止盈": "Tomar Ganancias",
  "止损": "Detener Pérdidas",
  "买入数量": "Cantidad de Compra",
  "每手": "Por Lote",
  "预估手续费": "Comisión Estimada",
  "预估保证金": "Margen Estimado",
  "买入": "Comprar",
  "卖出": "Vender",
  "您的订单已确认": "Su Orden ha sido Confirmada",
  "订单页面": "Página de Pedidos",
  "盈亏": "Ganancias y Pérdidas",
  "当前保证金": "Margen Actual",
  "订单详情": "Detalles del Pedido",
  "保证金": "Margen",
  "平仓": "Cerrar Posición",
  "修改": "Modificar",
  "手数": "Lotes",
  "暂无数据": "Sin Datos Disponibles",
  "历史": "Historial",
  "价格": "Precio",
  "请输入价格": "Por Favor, Introduzca el Precio",
  "手": "Lote",
  "搜索结果": "Resultados de Búsqueda",
  "搜索产品": "Buscar Productos",
  "持仓": "Posiciones",
  "语言": "Idioma",
  "审核中": "En Revisión",
  "请上传证件照正/反面": "Por Favor, Suba Fotos del Anverso y Reverso del Documento",
  "上传成功": "Subida Exitosa",
  "上传失败": "Fallo en la Subida",
  "提交成功": "Enviado con Éxito",
  "删除": "Eliminar",
  "删除成功": "Eliminado con Éxito",
  "提币": "Retirar",
  "缺少参数或传值错误": "Faltan Parámetros o Valores Incorrectos",
  "操作成功": "Operación Exitosa",
  "充值金额": "Monto del Depósito",
  "类型": "Tipo",
  "状态": "Estado",
  "时间": "Hora",
  "单位": "Unidad",
  "最高价": "Precio Máximo",
  "最低价": "Precio Mínimo",
  "开盘价": "Precio de Apertura",
  "请注册或登录真实账号": "Por Favor, Regístrese o Inicie Sesión con una Cuenta Real",
  "没有更多了": "No Hay Más",
  "提现金额": "Monto de Retiro",
  "审核通过": "Revisión Aprobada",
  "审核不通过": "Revisión Rechazada",
  "重新提交": "Reenviar",
  "止盈价": "Precio de Ganancias",
  "止损价": "Precio de Pérdidas",
  "总盈亏": "Ganancias y Pérdidas Totales",
  "撤单": "Cancelar Pedido",
  "请先进行实名认证": "Por Favor, Complete la Verificación de Identidad Primero",
  "产品列表": "Lista de Productos",
  "下单": "Realizar Pedido",
  "可用资金": "Fondos Disponibles",
  "欢迎登录": "Bienvenido",
  "可用": "Disponible",
  "冻结": "Congelado",
  "财务记录": "Historial Financiero",
  "交易对": "Par de Operación",
  "开仓时间": "Hora de Apertura",
  "收益": "Ganancias",
  "操作": "Acción",
  "下单价": "Precio del Pedido",
  "当前价": "Precio Actual",
  "订单号": "Número de Pedido",
  "请选择": "Por favor, elija",
  "卖出(做空)止损价不能低于开仓价": "El precio de stop-loss para la venta (corto) no puede ser menor que el precio de apertura",
  "卖出(做多)止盈价不能高于开仓价": "El precio de toma de ganancias para la venta (largo) no puede ser mayor que el precio de apertura",
  "买入(做多)止损价不能高于开仓价": "El precio de stop-loss para la compra (largo) no puede ser mayor que el precio de apertura",
  "买入(做多)止盈价不能低于开仓价": "El precio de toma de ganancias para la compra (largo) no puede ser menor que el precio de apertura",
  "买入(做多)止盈价不能低于开仓价和现价": "El precio de toma de ganancias para la compra (largo) no puede ser menor que el precio de apertura y el precio actual",
  "买入(做多)止损价不能高于开仓价和现价": "El precio de stop-loss para la compra (largo) no puede ser mayor que el precio de apertura y el precio actual",
  "卖出(做空)止损价不能低于开仓价和现价": "El precio de stop-loss para la venta (corto) no puede ser menor que el precio de apertura y el precio actual",
  "卖出(做多)止盈价不能高于开仓价和现价": "El precio de toma de ganancias para la venta (largo) no puede ser mayor que el precio de apertura y el precio actual",

  "提现手续费": "Comisión de retiro",
  "提现退回": "Devolución de retiro de efectivo",
  "系统加款": "Sistema más dinero",
  "系统减款": "Reducción del sistema",

  "交易周期": "Ciclo de transacción",
  "秒": "Segundo",
  "交易额": "Monto de la transacción",
  "买涨": "Comprar esperando un aumento",
  "买跌": "Comprar esperando una caída",
  "秒数": "Número de segundos",
  "交易类型": "Tipo de transacción",
  "看涨": "Ser optimista con el alza",
  "看跌": "Ser pesimista con el alza / Esperar una baja",
  "剩余时间": "Tiempo restante",
  "买入价": "Precio de compra",
  "结算价": "Precio de liquidación",
  "交易额": "Monto de la transacción",
  "下单时间": "Hora de colocar el pedido",
  "结算时间": "Hora de liquidación",
  "该币种暂无交易": "No hay transacciones en esta moneda.",

  "总资产": "Activos totales",
  "币种": "Moneda",
  "资产折合": "Conversión de activos",
  "冻结金额": "Monto bloqueado",
  "可用金额": "Monto disponible",
  "公司资产": "Activos de la empresa",
  "请输入旧密码": "Por favor, ingrese la contraseña anterior",
  "请输入新密码": "Por favor, ingrese la nueva contraseña",
  "请再次输入新密码": "Por favor, ingrese de nuevo la nueva contraseña",
  "白皮书": "Libro blanco",
  "注册证书": "Certificado de registro",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "El derecho de interpretación final de la información anterior corresponde a la autoridad oficial.",
  "上一页": "Página anterior",
  "下一页": "Próxima página",
  "关闭": "Cerrar",
  "闪电兑换": "Cambio instantáneo",
  "全部": "Todo",
  "可用余额": "Saldo disponible",
  "到": "Hasta",
  "请输入数量": "Por favor, ingrese la cantidad",
  "币种选择": "Selección de moneda",
  "从": "Desde",
  "兑换": "Cambiar",
  "兑换成功！": "¡El cambio fue exitoso!",
  "支付": "Pagar",
  "全部兑换成功": "Todos los cambios se realizaron exitosamente",
  "获取": "Obtener",
  "数量": "cantidad",
  "拒绝原因": "Razones del rechazo",
  "交易密码": "Contraseña de transacción",
  "设置交易密码": "Configurar la contraseña de transacción",
  "重置交易密码": "Restablecer la contraseña de transacción",
  "确定": "Confirmar",
  "是否购买？": "¿Comprar?",
  "外汇": "Divisas",
  "期权": "Opciones",
  "(用户中心)": "(Centro de Usuario)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Su transacción está siendo procesada, por favor espere pacientemente a que se complete antes de realizar otras operaciones.",
  "继续下单": "Continuar pedido",
  "交易方向": "Dirección de comercio",
  "实现盈利": "Obtener ganancias",
  "最新价格": "Precio más reciente",
  "结算完成": "Liquidación completada",
  "下单余额不足": "Saldo insuficiente para realizar el pedido",
  "输入交易额度": "Ingrese el monto de la transacción",
  "选择交易周期": "Seleccione el período de negociación",
  "审核拒绝": "Revisión rechazada",
  "请输入正确的数量!": "¡Por favor, ingrese la cantidad correcta!",
  "上传身份": "Subir identificación",
  "上传正面": "Subir lado frontal",
  "上传反面": "Subir lado posterior",
  "完善信息": "Completar información",
  "输入姓名": "Ingrese el nombre",
  "输入身份证号": "Ingrese el número de identificación",
  "身份证号": "Número de identificación",
  "请上传证件照正/反面": "Por favor suba el anverso/reverso del documento",
  "最小提现金额10USDT": "El retiro mínimo es de 10 USDT",
  "证件号码": "Número de documento",
  "输入证件号码": "Ingrese el número de documento",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "¡Por favor, suba su tarjeta de identidad, licencia de conducir o pasaporte para la verificación de identidad!"


}
